import ResaleReportActions from './ResaleReportActions';
import ResaleQuoteSection from './ResaleQuoteSection';
import { MARKET_CONDITION_LABELS, RESALE_SECTION_KEYS, RESALE_SECTION_LABELS } from '../lib/resaleScore';

export default function ResaleFinalizedView({ report, booking, onRefresh }) {
  const vehicle = [report.brand, report.model, report.year, report.plate_number]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="resale-finalized">
      <div className="resale-finalized-banner">
        <span className="material-symbol">verified</span>
        <div>
          <strong>Certified resale inspection</strong>
          <p>
            {report.report_number}
            {report.finalized_at
              ? ` · ${new Date(report.finalized_at).toLocaleString()}`
              : ''}
          </p>
        </div>
      </div>

      <div className="resale-finalized-hero">
        <strong className="resale-finalized-score">{report.overall_score}</strong>
        <span>
          {MARKET_CONDITION_LABELS[report.market_condition] || report.market_condition}
        </span>
        <p>{vehicle || 'Vehicle'}</p>
      </div>

      <div className="resale-finalized-seller">
        <div>
          <span className="muted">Seller</span>
          <strong>{report.seller_name || '—'}</strong>
        </div>
        <div>
          <span className="muted">Phone</span>
          <strong>{report.seller_phone || '—'}</strong>
        </div>
        <div>
          <span className="muted">City</span>
          <strong>{report.seller_city || '—'}</strong>
        </div>
        {report.inspector_name ? (
          <div>
            <span className="muted">Inspector</span>
            <strong>{report.inspector_name}</strong>
          </div>
        ) : null}
      </div>

      <div className="resale-finalized-grid">
        {RESALE_SECTION_KEYS.map((key) => {
          const section = report.sections?.[key] || {};
          return (
            <div key={key} className="resale-finalized-card">
              <span>{RESALE_SECTION_LABELS[key]}</span>
              <strong>{section.score ?? '—'}</strong>
              <em>{section.status || '—'}</em>
            </div>
          );
        })}
      </div>

      {report.summary_notes ? (
        <div className="resale-finalized-detail">
          <span>Summary</span>
          <p>{report.summary_notes}</p>
        </div>
      ) : null}

      <ResaleReportActions report={report} booking={booking} onRefresh={onRefresh} />
      <ResaleQuoteSection report={report} booking={booking} />
    </div>
  );
}
